import { PublicationItemFragment } from '@sketch/gql-types'
import React from 'react'

import { Wrapper, ListPublicationItem } from './PublicationList.styles'

interface PublicationListProps {
  className?: string
  items: PublicationItemFragment[]
}

const PublicationList = (props: PublicationListProps) => {
  const { className, items } = props

  return (
    <Wrapper className={className}>
      {items.map(publication => (
        <ListPublicationItem
          key={publication.identifier}
          publication={publication}
        />
      ))}
    </Wrapper>
  )
}

export default PublicationList
